let scrollState = {
  direction: null,
  speed: 0,
  rafId: null,
  scrollRef: null,
  checkScroll: null
};

const smoothScroll = () => {
  if (scrollState.scrollRef && scrollState.direction) {
    scrollState.scrollRef.scrollBy({
      left: scrollState.speed,
      behavior: 'auto'
    });
    scrollState.rafId = requestAnimationFrame(smoothScroll);
    if (scrollState.checkScroll) {
      scrollState.checkScroll();
    }
  }
};

export const startScrolling = (scrollRef, direction, speed = 5, checkScroll) => {
  if (!scrollState.rafId) {
    scrollState.scrollRef = scrollRef.current;
    scrollState.direction = direction;
    scrollState.speed = direction === 'left' ? -speed : speed;
    scrollState.checkScroll = checkScroll;
    scrollState.rafId = requestAnimationFrame(smoothScroll);
  }
};

export const stopScrolling = () => {
  if (scrollState.rafId) {
    cancelAnimationFrame(scrollState.rafId);
    scrollState = {
      direction: null,
      speed: 0,
      rafId: null,
      scrollRef: null,
      checkScroll: null
    };
  }
};
